exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-responsive-sm {\n  \n  -webkit-box-shadow: 0 5px 5px rgba(0, 0, 0, .5);\n  \n          box-shadow: 0 5px 5px rgba(0, 0, 0, .5);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Michel/Documents/edenz_local/cellwatchWebApp/src/app/types/types.component.css
// module id = ../../../../../src/app/types/types.component.css
// module chunks = main